import { render, staticRenderFns } from "./PhonePrefix.vue?vue&type=template&id=1969ea6d"
import script from "./PhonePrefix.vue?vue&type=script&lang=ts"
export * from "./PhonePrefix.vue?vue&type=script&lang=ts"
import style0 from "./PhonePrefix.vue?vue&type=style&index=0&id=1969ea6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports